import axios from '@/zenky';

export default async function () {
  const reqData = {
    phone: this.phone,
    phone_country: this.phone_country,
  };

  const recaptchaToken = await this.$store.dispatch('recaptcha/getToken', 'reset_password');

  if (recaptchaToken) {
    reqData.recaptcha = { token: recaptchaToken };
  }

  const req = axios.post('/auth/password/request', reqData);

  try {
    await req;
  } catch (err) {
    // Technically it may also return a `auth.user_not_found` error or that the phone field contains an invalid number,
    // but we've checked it before by calling `/auth/check`.
    // TODO check for cooldown error, when the backend has it
    // if (handleApiCooldownErrorIfPresent.call(this, err)) return;
    throw err;
  }

  this.stage = 'code';
};
